import { isObjectEmpty } from "@omnia/shared/utils/objects";
import { pascalCaseKeys } from "../../../../shared/case";
import { getUserPermissions } from "../../../../shared/permissions/user/user";
import { DefaultPermissions } from "../../defaults/defaults";
import { ApiUser } from "./api";
import { convertCroppingPermissionsFromApi } from "./cropping";
import { compareHoldingPermissions, convertFromHoldingPermissions, convertToHoldingPermissions } from "./permissions";
import { compareCroppingPermissions, getCroppingForUpdatedUser } from "./state/cropping";
import { Cropping, EditorUser, User, UserPermissions, UserUpdate } from "./types";

export function setupUserFromApi(api: ApiUser, ownerPermissions: UserPermissions, defaultPermissions: DefaultPermissions): User {

    const targetMemberPermissions = getUserPermissions(
        pascalCaseKeys(api.userPermissions),
        api.userRole
    )

    const userDefaults = defaultPermissions[api.userRole]

    return {
        ...api,
        userPermissions: targetMemberPermissions,
        displayName: getDisplayName(api),
        holdingPermissions: convertFromHoldingPermissions(api.holdingPermissions, targetMemberPermissions, ownerPermissions, userDefaults),
        croppingPermissions: convertCroppingPermissionsFromApi(api.croppingPermissions)
    }
}

function getDisplayName({ firstName, lastName, email, userId }: ApiUser) {

    const name = [firstName, lastName].filter(n => !!n).join(" ") || email || `User #${userId}`

    return name

}

export function cancelUserChanges(user: EditorUser): EditorUser {

    if (!(user.updated || user.deleted)) {
        return user
    }

    return validateUser({
        ...user,
        deleted: false,
        updated: false,
        ...user.initialState
    })

}

export function getUserUpdates(users: EditorUser[], cropping: Cropping[]): UserUpdate[] {

    return users
        .filter(u => u.updated || u.deleted)
        .map(u => ({

            userId: u.userId,

            email: u.email,
            delete: u.deleted,

            holdingRole: (!u.deleted) && (u.holdingRole !== u.initialState.holdingRole)
                ? u.holdingRole
                : undefined,

            holdingPermissions: (!u.deleted)
                ? convertToHoldingPermissions(u.holdingPermissions)
                : undefined,

            croppingPermissions: (!u.deleted) && u.restrictCroppingAccess
                ? getCroppingForUpdatedUser(u.croppingPermissions, cropping)
                : undefined

        }))

}

export function validateUser(user: EditorUser): EditorUser {

    const updated = (user.holdingRole !== user.initialState.holdingRole)
        || (!compareHoldingPermissions(user.holdingPermissions, user.initialState.holdingPermissions))
        || (user.restrictCroppingAccess !== user.initialState.restrictCroppingAccess)
        || (!compareCroppingPermissions(user.croppingPermissions, user.initialState.croppingPermissions))

    return {
        ...user,
        updated
    }

}
